import React, { useState, useCallback, useRef, useEffect } from 'react';
import { StyledButton } from './styled';
import { ButtonProps } from './types';

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  buttonType = 'default',
  value,
  className,
  preventDoubleClick = false,
  cooldownMs = 400,
  onClick,
  disabled,
  ...rest
}, ref) => {
  const [isInCooldown, setIsInCooldown] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    if (!preventDoubleClick) {
      onClick?.(event);
      return;
    }

    if (isInCooldown) {
      return;
    }

    setIsInCooldown(true);
    onClick?.(event);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setIsInCooldown(false);
    }, cooldownMs);
  }, [onClick, preventDoubleClick, cooldownMs, isInCooldown]);

  return(
    <StyledButton
      ref={ref as any}
      className={`${buttonType} ${className ?? ''}`}
      onClick={handleClick}
      disabled={disabled || isInCooldown}
      {...rest}
    >
      {value ?? ''}
    </StyledButton>
  )
});

export default Button;
